/** Narrows an unknown value to a plain object, so its properties can be read as `unknown`. `null` and arrays are not records. */
export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
